import Helmet from "react-helmet"
import React from "react"
import Disclosure from "@tightrope/disclaimers";
import ExtendedHomepage from "src/components/extendedHomepage"
import HomepageLayout from "src/layouts/homepage"
import RawFooter from "@tightrope/footerlinks/rawfooter.js"
import {isIeEdge,isChrome,isFirefox, isSafari} from "@tightrope/lpscripts/browserdetect"


const homepageData = import("./homepage.json");
const footer = <RawFooter></RawFooter>

export default function HomePage() {
  let disclosure = null;

  if(isIeEdge()){
      disclosure = <Disclosure></Disclosure>;
  }
 if(isFirefox()){
      disclosure = <Disclosure></Disclosure>;

  }
 if(isSafari()) {
     disclosure = <Disclosure></Disclosure>;
 }
  if(isChrome()){
        disclosure = <Disclosure></Disclosure>;
    }
  return(
    <HomepageLayout>
      <Helmet>
      <link rel="icon" href="/img/favicon.png" sizes="32x32" />
      <style type="text/css">{`
      * {
		font-family: 'Fira Sans', sans-serif;
	}
      #disclaimers-module--disclaimers p, #disclaimers-module--disclaimers a {
      color: #4d5052;
		  font-size: 12px;
		  text-align: center;
		  width: 360px;
      letter-spacing: -0.5px;
      line-height: 135%;
      font-weight: 300;
}
      .footerDisc #disclaimers-module--disclaimers p,  .footerDisc #disclaimers-module--disclaimers a {
      color: #eaf5ef;
		  font-size: 12px;
		  text-align: center;
		  width: 360px;
      letter-spacing: -0.5px;
      line-height: 135%;
      font-weight: 300;
      margin:0;
}
        footer {
          position: relative;
          width: 100%;
          padding: 0;
          margin:0;
          z-index: 1;
          background:#41637b;
          border:none;
        }
        footer ul {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap:wrap;
          color: #eaf5ef;
          font-size: 12px;
          padding: 10px 0;
          list-style:none;
        }
        footer ul li {
          margin: 0;
        }
        footer ul li a {
          text-decoration: none;
          color: #eaf5ef;
        }
          footer ul li a:hover {
          text-decoration: none;
          color: #eaf5ef;
        }
        footer ul li:after {
          content: '|';
          padding: 0 4px;
        }
        footer ul li:last-child:after {
          content: none;
          padding: 0;
        }

        @media screen and (max-width: 1366px) {
        #disclaimers-module--disclaimers p, #disclaimers-module--disclaimers a {
		  width: 432px;
      font-size: 12px;
}

      }

        @media screen and (max-width: 576px) {
      }

        

                

        `}</style>
      <title>All-in-One Search | AllSearch</title></Helmet>
      <ExtendedHomepage data={homepageData}>
      <div className="disc">{disclosure}</div>
      </ExtendedHomepage>
      <RawFooter></RawFooter>
    </HomepageLayout>
  )
}